import React from "react";
import { motion } from "framer-motion";
import { Coins, Landmark, Cpu, ClipboardList, LifeBuoy, FileText } from "lucide-react";
import { DESTACADAS, AREAS } from "../../data";

const ICONS = { Coins, Landmark, Cpu, ClipboardList, LifeBuoy, FileText };

export default function Destacadas() {
  return (
    <section id="areas" className="py-20 lg:py-28 bg-white border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-espana-red mb-3">
            Tres prioridades
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-tight">
            No todo pesa igual. Empezamos por lo que más importa.
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {DESTACADAS.map((d, i) => {
            const Icon = ICONS[d.icon];
            return (
              <motion.div
                key={d.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`destacada-${i}`}
                className="group relative bg-white border border-gray-200 p-8 hover:-translate-y-1 hover:shadow-md transition-transform"
              >
                <span className="absolute top-0 left-0 h-1 w-16 bg-espana-red group-hover:w-full transition-all duration-300" />
                <div className="h-12 w-12 flex items-center justify-center bg-espana-red/10 text-espana-red mb-5">
                  <Icon size={26} strokeWidth={2} />
                </div>
                <h3 className="text-xl font-bold mb-2">{d.title}</h3>
                <p className="text-gray-600 leading-relaxed">{d.text}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gray-400 mb-6">
            Explora todas las áreas
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            {AREAS.map((a) => {
              const Icon = ICONS[a.icon];
              return (
                <div
                  key={a.title}
                  data-testid={`area-${a.title}`}
                  className="bg-white p-6 flex items-start gap-4 hover:bg-gray-50 transition-colors"
                >
                  <Icon size={22} className="text-espana-red mt-0.5 shrink-0" strokeWidth={2} />
                  <div>
                    <h4 className="font-bold">{a.title}</h4>
                    <p className="text-sm text-gray-500 mt-1">{a.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
